Hi {{ user()!.displayName || user()!.email }},
<br />
<br />
Thank you for signing up for Moddy AI. We're excited to have you on board!
<br />
You've successfully created your account, and by signing up, you agreed to our:
<br />

<ul class="legal-items">
    @for (legalItem of legalItems; track legalItem) {
        <li>
            <div class="flex items-center">
                <p-checkbox
                    [name]="legalItem.name"
                    [binary]="true"
                    [(ngModel)]="legalItem.isChecked" />

                <a
                    [attr.href]="legalItem.url"
                    target="_blank"
                    tabindex="-1">
                    <p-button
                        [label]="legalItem.name"
                        [size]="'small'"
                        [link]="true"
                        [icon]="'pi pi-external-link'"
                        [iconPos]="'right'" />
                </a>
            </div>
        </li>
    }
</ul>

Please take a moment to review these important documents, and feel free to reach out if you have any questions.
<br />
<br />
Best regards,
<br />
The Moddy AI Team.

<div class="dialog-footer">
    <p-button
        [label]="'I accept the above terms and policies'"
        [loading]="isAcceptButtonLoading()"
        [disabled]="!isAllLegalItemsChecked()"
        (onClick)="onAcceptButtonClick()" />
</div>
